import React from 'react';

export const CheckIcon = ({ width = 16, height = 16, fill = "#A4A3B1", color =  "#A4A3B1" }) => (
    <svg width={`${width}px`} height={`${height}px`} strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path d="M5 13L9 17L19 7" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>)